const NotificationsHistory = () => import('./_views/notificationsHistory');

export default [
  {
    path: '/notifications-history',
    name: 'notificationsHistory',
    component: NotificationsHistory,
    meta: {
      title: 'Notifications History',
    },
  },
];
